"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validCoordinates = exports.getYTranslation = exports.getXTranslation = void 0;
var MARGIN = 8;

var getXTranslation = function getXTranslation(tooltipRect, elementRect, location) {
  var scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;

  if (location === 'left') {
    return Math.round(elementRect.left + scrollLeft - MARGIN - tooltipRect.width);
  }

  if (location === 'right') {
    return Math.round(elementRect.right + scrollLeft + MARGIN);
  }

  var hAlignment = elementRect.width / 2 - tooltipRect.width / 2;
  return Math.round(elementRect.left + hAlignment + scrollLeft);
};

exports.getXTranslation = getXTranslation;

var getYTranslation = function getYTranslation(tooltipRect, elementRect, location) {
  var scrollTop = window.pageYOffset || document.documentElement.scrollTop;

  if (location === 'top') {
    return Math.round(elementRect.top + scrollTop - MARGIN - tooltipRect.height);
  }

  if (location === 'bottom') {
    return Math.round(elementRect.bottom + scrollTop + MARGIN);
  }

  var vAlignment = elementRect.height / 2 - tooltipRect.height / 2;
  return Math.round(elementRect.top + vAlignment + scrollTop);
};

exports.getYTranslation = getYTranslation;

var validCoordinates = function validCoordinates(x, y, width, height) {
  var minimumX = window.pageXOffset;
  var maximumX = window.pageXOffset + window.innerWidth;
  var minimumY = window.pageYOffset;
  var maximumY = window.pageYOffset + window.innerHeight;

  if (!x || !y) {
    return false;
  }

  if (typeof x !== 'number' || typeof y !== 'number') {
    return false;
  }

  if (x < minimumX || x + width > maximumX) {
    return false;
  }

  if (y < minimumY || y + height > maximumY) {
    return false;
  }

  return true;
};

exports.validCoordinates = validCoordinates;